import React, {useEffect} from 'react';
import {jsPDF} from 'jspdf';
import autoTable from 'jspdf-autotable';
import addFont from '../../../assets/fonts/fonts';
import {tableNamesСandidates} from '../../../utils/const';
import moment from 'moment';
import 'moment/locale/ru';

// Ориентация и опции для текста
const orientation = 'p';
const option = {
    maxWidth: 180,
    align: 'center'
};

const ScholarshipTable = ({
    candidatslist,
    amo,
    government,
    ksmo,
    chief,
    GOU,
    getCandidatsForFileTrash,
    yearsLocal,
    heads,
}) => {
    const heads_ = [...heads];
    // Трансформация данных для таблиц
    const transformData = (data) => {
        const tables = {
            amo: [],
            government: [],
            ksmo: []
        };

        // Обработка данных для "amo"
        if (amo) {
            for (const [key,
                candidates]of Object.entries(amo)) {
                if (candidates.length > 0) {
                    const tableData = candidates.map((candidate, index) => ({
                        '№ п/п': index + 1,
                        'Воинская должность': candidate.prep_struc_category,
                        'Воинское звание': candidate.militaryrank,
                        'Фамилия Имя Отчество': candidate.student_name,
                        'Личный номер': candidate.number,
                        'Курс (год подготовки) на год выплаты стипендии': candidate.yeducationyear
                    }));

                    tables
                        .amo
                        .push({title: key, listFile: tableData});
                }
            }
        }
        
        if (ksmo) {
            for (const [key,
                candidates]of Object.entries(ksmo)) {
                if (candidates.length > 0) {
                    const tableData = candidates.map((candidate, index) => ({
                        '№ п/п': index + 1,
                        'Воинская должность': candidate.prep_struc_category,
                        'Воинское звание': candidate.militaryrank,
                        'Фамилия Имя Отчество': candidate.student_name,
                        'Личный номер': candidate.number,
                        'Курс (год подготовки) на год выплаты стипендии': candidate.yeducationyear
                    }));

                    tables
                        .ksmo
                        .push({title: key, listFile: tableData});
                }
            }
        }

        // Обработка данных для "government"
        if (government) {
            for (const [key,
                candidates] of Object.entries(government)) {
                if (candidates.length > 0) {
                    const tableData = candidates.map((candidate, index) => ({
                        '№ п/п': index + 1,
                        'Воинская должность': candidate.prep_struc_category,
                        'Воинское звание': candidate.militaryrank,
                        'Фамилия Имя Отчество': candidate.student_name,
                        'Личный номер': candidate.number,
                        'Курс (год подготовки) на год выплаты стипендии': candidate.yeducationyear
                    }));

                    tables
                        .government
                        .push({title: key, listFile: tableData});
                }
            }
        }

        return tables;
    };

    // Генерация PDF
    const generatePDF = async(tables, title, heads_) => {

        // Добавление шрифта
        addFont(jsPDF.API);
        let lines = null;
        // Создание документа
        const doc = new jsPDF({orientation});

        // Установка шрифта для основного текста
        doc.setFont('TimesNewRoman');
        doc.setFontSize(14);

        let currentY = 10;

        const fun = (text, w, current, align) => {
            doc.text(`${text}`, w, current, align);
            lines = doc.splitTextToSize(`${text}`, w);
            currentY = current + 10 + (doc.getTextDimensions(`${text}` || '-').h * lines.length)
        }

        // Заголовок документа
            // fu   n(`${heads_[0]?.post && heads_[0]?.rank && heads_[0]?.name && heads_[0]?.date ? 'УТВЕРЖДАЮ' : '   '}`, 175, currentY, {align: 'right'});
            // fun(`${heads_[0].post || '   '}`, 160, currentY - 9, option);
            // fun(`${heads_[0].rank || '   '}                           ${heads_[0].name || '   '}`, 195, currentY - 9, {align: 'right'});
            // fun(`${heads_[0]?.date ? moment(heads_[0]?.date).format('D MMMM YYYY г.') : '   '}`, 110, currentY - 9, {align: 'center'});
            
            if (heads_[0].post && heads_[0].name && heads_[0].rank ) {
                let len1 = (doc.getTextDimensions(`${`${heads_[0].rank}                           ${heads_[0].name}`}`).w);
                let len2 = (doc.getTextDimensions(`${`${heads_[0].post}`}`).w);
                let getMaxLen = Math.max(len1, len2);
                doc.text("УТВЕРЖДАЮ", doc.internal.pageSize.width - 9 - (getMaxLen) / 2, 10, { align: "center" });
                doc.text(`${heads_[0].post}`, doc.internal.pageSize.width - 9 - (getMaxLen) / 2, 17, { align: "center" });
                doc.text(
                  `${heads_[0].rank}                           ${heads_[0].name}`,
                  doc.internal.pageSize.width - 9 - (getMaxLen) / 2,
                  24,
                  { align: "center" }
                );
                doc.text(
                  `${heads_[0].date ? moment(heads_[0].date || null).format("D MMMM YYYY г.") : ''}`,
                  doc.internal.pageSize.width - 9 - (getMaxLen),
                  31,
                  { align: "left" }
                );
            }
            currentY = currentY + 40;
            doc.setFont('TimesNewRomanBold');
        fun('С П И С О К', 105, currentY - 5, option);

        if (title === 'Список кандидатов на стипендию МО РФ (Адъюнкты)') {
            fun('отобранных кандидатов на стипендии Министерства обороны Российской Федерации для' +
                    ' адъюнктов федеральных государственных организаций, осущ' +
                    'ествляющих образовательную деятельность, находящихся в ведении Министерства обор' +
                    'оны Российской Федерации',
            105, currentY - 8, option);
        } else if (title === 'Список кандидатов на стипендию Президента и Правительства РФ') {
            fun('отобранных кандидатов на стипендии Президента Российской Федерации и стипендии П' +
                    'равительства Российской Федерации для слушателей, курсантов военных профессиона' +
                    'льных образовательных организаций и военных образовательных организаций высшего ' +
                    ' образования Министерства обороны Российской Федерации',
            105, currentY - 8, option);
        } else if (title === 'Список кандидатов на стипендию Министерства Обороны РФ') {
            fun('отобранных кандидатов на стипенди Министерства обороны Российской Федерации' +
                    ' для курсантов и слушателей федеральных государственных организаций ' +
                    ' высшего образования, осуществляющих образовательную деятельность, находящихся' +
                    ' в ведении Министерства обороны Российской Федерации',
            105, currentY - 8, option);
        }

        doc.setFontSize(16);
        doc.setFont('TimesNewRoman');
        if ( title === 'Список кандидатов на стипендию Министерства Обороны РФ' ) {
            fun(`в ${yearsLocal} учебном году`, 105, currentY - 18, option);
        } else {
            fun(`в ${yearsLocal} учебном году`, 105, currentY - 22, option);
        }
        // doc.text(`в ${yearsLocal} учебном году`, 105, currentY + 5, option);

        const tableColumnWidths = {
            0: { cellWidth: 0.05 * doc.internal.pageSize.width, halign: 'center' }, // 10% ширины страницы
            1: { cellWidth: 0.15  * doc.internal.pageSize.width, halign: 'center' }, // 30% ширины страницы
            2: { cellWidth: 0.15  * doc.internal.pageSize.width, halign: 'center' }, // 30% ширины страницы
            3: { cellWidth: 0.25 * doc.internal.pageSize.width, halign: 'center' },  // 60% ширины страницы
            4: { cellWidth: 0.20  * doc.internal.pageSize.width - 14, halign: 'center' }, // 30% ширины страницы
            5: { cellWidth: 0.20  * doc.internal.pageSize.width - 14, halign: 'center' }, // 30% ширины страницы
        };
        const tableColumnWidthsTitle = {
            0: { cellWidth: 'wrap' }, // 100% ширины страницы
        };

        const getSort = (data) => {
            return data.sort((a, b) => {
                const nameA = a["Фамилия Имя Отчество"];
                const nameB = b["Фамилия Имя Отчество"];
                return nameA.localeCompare(nameB, 'ru');
            }).map(Object.values);
        }

        // Генерация таблиц
        currentY = currentY - 5; 
        tables.forEach((table, index) => {
            // Центрируем текст заголовка 
            // doc.text(tableNamesСandidates[table.title], 105, currentY, option);

            {
                index === 0 && autoTable(doc, {
                    head: null,
                    body: index === 0 && [Object.keys(table.listFile[0])],
                    startY: index === 0 && currentY,
                    columnStyles: tableColumnWidths,
                    bodyStyles: {
                        textColor: [
                            0, 0, 0
                        ], // Чёрный цвет линий
                    },
                    styles: {
                        cellWidth: 'wrap',
                        font: "TimesNewRoman",
                        fontSize: 14, // Уменьшенный размер шрифта для строгого вида
                        cellPadding: 2, // Меньший отступ в ячейках
                        halign: 'center', // Выравнивание текста по центру
                        valign: 'middle', // Вертикальное выравнивание текста
                        lineWidth: 0.1, // Тонкие границы ячеек
                        lineColor: [
                            0, 0, 0
                        ], // Чёрный цвет границ
                    },
                    headStyles: {
                        cellWidth: 'wrap',
                        fillColor: [
                            255, 255, 255
                        ], // Светло-серый цвет для заголовков
                        textColor: [
                            0, 0, 0
                        ], // Чёрный текст заголовков
                        fontStyle: 'bold', // Жирный текст в заголовках
                    },
                    alternateRowStyles: {
                        fillColor: [
                            255, 255, 255
                        ], // Очень светлый серый для чередующихся строк
                    },
                    tableLineColor: [
                        0, 0, 0
                    ], // Цвет линий таблицы
                    bodyStyles: {
                        textColor: [
                            0, 0, 0
                        ], // Чёрный цвет линий
                    },
                    tableLineWidth: 0.1, // Толщина линий таблицы
                });}

            doc.autoTable({
                head: null,
                body: [
                    [tableNamesСandidates[table.title]]
                ],
                startY: index == 0 ? doc.lastAutoTable.finalY : currentY,
                columnStyles: tableColumnWidthsTitle,
                styles: {
                    cellWidth: 'wrap',
                    font: "TimesNewRoman",
                    fontSize: 14, // Уменьшенный размер шрифта для строгого вида
                    cellPadding: 2, // Меньший отступ в ячейках
                    halign: 'center', // Выравнивание текста по центру
                    valign: 'middle', // Вертикальное выравнивание текста
                    lineWidth: 0.1, // Тонкие границы ячеек
                    lineColor: [
                        0, 0, 0
                    ], // Чёрный цвет границ
                },
                headStyles: {
                    fillColor: [
                        255, 255, 255
                    ], // Светло-серый цвет для заголовков
                    textColor: [
                        0, 0, 0
                    ], // Чёрный текст заголовков
                    fontStyle: 'bold', // Жирный текст в заголовках
                },
                alternateRowStyles: {
                    fillColor: [
                        255, 255, 255
                    ], // Очень светлый серый для чередующихся строк
                },
                tableLineColor: [
                    0, 0, 0
                ], // Цвет линий таблицы
                bodyStyles: {
                    textColor: [
                        0, 0, 0
                    ], // Чёрный цвет линий
                },
                tableLineWidth: 0.1, // Толщина линий таблицы
            });

            // Добавляем таблицу

            autoTable(doc, {
                head: null,
                // body: getSort(table.listFile),
                body: table.listFile.map(Object.values),
                startY: doc.lastAutoTable.finalY,
                columnStyles: tableColumnWidths,
                bodyStyles: {
                    textColor: [
                        0, 0, 0
                    ], // Чёрный цвет линий
                },
                styles: {
                    cellWidth: 'wrap',
                    font: "TimesNewRoman",
                    fontSize: 14, // Уменьшенный размер шрифта для строгого вида
                    cellPadding: 2, // Меньший отступ в ячейках
                    halign: 'center', // Выравнивание текста по центру
                    valign: 'middle', // Вертикальное выравнивание текста
                    lineWidth: 0.1, // Тонкие границы ячеек
                    lineColor: [
                        0, 0, 0
                    ], // Чёрный цвет границ
                },
                headStyles: {
                    cellWidth: 'wrap',
                    fillColor: [
                        255, 255, 255
                    ], // Светло-серый цвет для заголовков
                    textColor: [
                        0, 0, 0
                    ], // Чёрный текст заголовков
                    fontStyle: 'bold', // Жирный текст в заголовках
                },
                alternateRowStyles: {
                    fillColor: [
                        255, 255, 255
                    ], // Очень светлый серый для чередующихся строк
                },
                tableLineColor: [
                    0, 0, 0
                ], // Цвет линий таблицы
                bodyStyles: {
                    textColor: [
                        0, 0, 0
                    ], // Чёрный цвет линий
                },
                tableLineWidth: 0.1, // Толщина линий таблицы
            });


            if (currentY > 230) {
                // doc.addPage();
                // currentY = 15;
            } else {
                currentY = doc.lastAutoTable.finalY
            }
            // if (index == tables.length - 1) {
            //     currentY = doc.lastAutoTable.finalY;
            // }
        });
        

        doc.setFontSize(16);
        // Заключительная часть
        // currentY = doc.lastAutoTable.finalY

        heads_.filter(el => el?.id != 1).map((head_el, i) => {
            currentY = i == 0 ? doc.lastAutoTable.finalY : currentY
            if (currentY + 30 > 255) {
                doc.addPage();
                currentY = 15;
            } else {
                // currentY = doc.lastAutoTable.finalY;
            }
            // doc.text(`${head_el.title}`, 50, currentY + 12, option);
            doc.text(`${head_el.post}`, 100, currentY + 14, option);
            doc.text(`${head_el.rank}                                ${head_el.name}`, 100, currentY + 20, option);
            doc.text(`        ${head_el?.date ? moment(head_el?.date).format('D MMMM YYYY г.') : '   '}`, 65, currentY + 28, option);
            currentY = currentY + 32;
        })
        // Сохранение PDF
        doc.save(`${title}.pdf`);
    };

    // Обработка генерации PDF для "amo" и "government"
    const handleGeneratePDF = (type, data) => {
        const transformedData = transformData(data);
        if (transformedData.amo.length > 0 && type === 'amo') {
            const amo = transformedData.amo;
            generatePDF(amo, 'Список кандидатов на стипендию МО РФ (Адъюнкты)', heads_);
            getCandidatsForFileTrash(type);
        }

        if (transformedData.government.length > 0 && type === 'government') {
            const government = transformedData.government;
            const newGov = [
                {
                    title: 'president_scholarship_candidates_higher_cadet_listener',
                    listFile: government.find(el => el
                        ?.title === 'president_scholarship_candidates_higher_cadet_listener')
                        ?.listFile
                }, {
                    title: 'government_scholarship_candidates_higher_cadet_listener',
                    listFile: government.find(el => el
                        ?.title === 'government_scholarship_candidates_higher_cadet_listener')
                        ?.listFile
                }, {
                    title: 'government_scholarship_candidates_secondary_cadet',
                    listFile: government.find(el => el
                        ?.title === 'government_scholarship_candidates_secondary_cadet')
                        ?.listFile
                }
            ].filter(el => el
                ?.listFile
                    ?.length > 0);
            generatePDF(newGov, 'Список кандидатов на стипендию Президента и Правительства РФ', heads_);
            getCandidatsForFileTrash(type);
        }
        
        if (transformedData.ksmo.length > 0 && type === 'ksmo') {
            const ksmo = transformedData.ksmo;
            const newGov = [
                {
                    title: 'scholarship_candidates_higher_cadet',
                    listFile: ksmo.find(el => el
                        ?.title === 'scholarship_candidates_higher_cadet')
                        ?.listFile
                }, {
                    title: 'scholarship_candidates_higher_listener',
                    listFile: ksmo.find(el => el
                        ?.title === 'scholarship_candidates_higher_listener')
                        ?.listFile
                }
            ].filter(el => el
                ?.listFile
                    ?.length > 0);
            generatePDF(newGov, 'Список кандидатов на стипендию Министерства Обороны РФ', heads_);
            getCandidatsForFileTrash(type);
        }
    };

    useEffect(() => {
        if (amo) {
            handleGeneratePDF('amo', amo);
        }
    }, [amo]);

    useEffect(() => {
        if (government) {
            handleGeneratePDF('government', government);
        }
    }, [government]);
    
    useEffect(() => {
        if (ksmo) {
            handleGeneratePDF('ksmo', ksmo);
        }
    }, [ksmo]);

    return (<></>);
};

export default ScholarshipTable;
